/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { styled } from '@mui/material';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

function TextFieldInputCity({ address, textSize, disabled }) {
  //------------コンポーネントのスタイル------------
  const styles = {
    textarea:{
      width: '90%',

      '& .MuiInputBase-input':{
        fontSize: textSize,
      },
      '& .MuiInputBase-root':{
        // padding: '3px 0.5rem',
      },
      '& .MuiInputLabel-root':{
        fontSize: textSize,
      }
    },
    inputItemForm:{
      display:'flex',
      alignItems: 'center',
    },
    paddingLeft5:{
      paddingLeft: '5px',
    }
  }
  //------------コンポーネントのスタイル------------

  return (
    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
      <TextField
        id="city"
        label="市区町村"
        size="small"
        value={address.address2}
        css={styles.textarea}
        disabled={disabled}
      />
    </Grid>
  );
}
export default TextFieldInputCity;